export default __webpack_public_path__ + "static/media/rating-icon.6b13e4b0.svg";